<script setup>
import { ref, toRefs, watch } from "vue";
import * as amplitude from "@amplitude/analytics-browser";
import Modal from "@/components/Modal.vue";
import withTimeLimit from "../../utils/asyncHelpers.js";

const props = defineProps({
  visible: Boolean,
  toggle: Function,
  exitURL: String
});

const { visible, exitURL } = toRefs(props);
const isVisible = ref(visible);

watch(visible, () => {
  isVisible.value = visible.value;
});

async function goToPhotoAuth() {
  await withTimeLimit(amplitude.track("2nd timeout - go to PA", window.amplitudeCommonProperties).promise.then(() => amplitude.flush()));
  window.location.href = `${window.location.origin}/${import.meta.env.VITE_PHOTO_AUTH_PREFIX}${window.location.search}`;
}

async function close() {
  await withTimeLimit(amplitude.track("2nd timeout - exit", window.amplitudeCommonProperties).promise.then(() => amplitude.flush()));
  window.location.href = exitURL.value;
}
</script>

<template>
<Modal v-if="isVisible" @close="toggle()">
  <template #title>
    {{ $t("video_quality") }}
  </template>
  <template #description>
    {{ $t("not_good_live") }}
    <br />
    <br />
    {{ $t("take_close_photo") }}
  </template>
  <template #footer>
    <div class="text-center text-lg text-[var(--secondary)]" @click="close()">
      {{ $t("try_again") }}
    </div>
    <div class="text-center text-lg text-[var(--secondary)]" @click="goToPhotoAuth()">
      {{ $t("btn_photo_auth") }}
    </div>
  </template>
</Modal>
</template>
